// import { Component, OnInit } from '@angular/core';
import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { Router } from "@angular/router";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { OrganizationResponseModel } from "src/app/model/OrganizationResponseModel";
import { Page } from "src/app/model/Page";
import { MasterService } from "src/app/services/master.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSort } from "@angular/material/sort";
import { SopResponseModel } from "src/app/model/SopResponseModel";

@Component({
  selector: "app-secure-sop-management-list",
  templateUrl: "./sop-management-list.component.html",
  styleUrls: ["./sop-management-list.component.scss"],
})
export class SopManagementListComponent implements OnInit {
  page: Page<SopResponseModel>;
  dataSource: MatTableDataSource<BoardResponseModel> = new MatTableDataSource();
  pageSizeOptions: number[] = [10, 25, 100];
  isLoading = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  isSearchDisabled: boolean = false;
  nonEditable: boolean;
  dataSourceLottery: MatTableDataSource<SopResponseModel> =
    new MatTableDataSource();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "id",
    "lotteryCode",
    "lotteryName",
    "lotteryStage",
    "SopType",
    "action",
  ];

  constructor(
    public dialog: MatDialog,
    private masterService: MasterService,
    private router: Router,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.filterForm = new FormGroup({
      filterText: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
    });

    this.onLoad();
  }

  resetFilter() {
    this.filterForm.controls["filterText"].setValue(null);
    this.onLoad();
  }

  onLoad() {
    this.isLoading = true;
    this.masterService
      .fetchSopLotteryList(
        this.currentPage,
        this.pageSize,
        this.filterForm.value.filterText
      )
      .subscribe(
        (data) => {
          this.isLoading = false;
          this.isSearchDisabled = false;
          if (data.status === "SUCCESS") {
            this.page = data.page;
            this.nonEditable = data.nonEditable;
            this.dataSourceLottery = new MatTableDataSource(this.page.content);
            setTimeout(() => {
              this.paginator.pageIndex = this.currentPage;
              this.paginator.length = this.page.totalElements;
            });
          } else {
            this.nonEditable = true;
            this.masterService.errorToast(data.errorMessage);
          }
        },
        (error) => {
          console.log(error);
          this.isLoading = false;
          this.isSearchDisabled = false;
          this.nonEditable = true;
        }
      );
  }

  onSearch() {
    if (this.filterForm.valid) {
      console.log("onSearch");
      console.log(this.filterForm.valid);
      this.onLoad();
    } else {
      this._snackBar.open(
        "Please enter Filter text (minimum - 3 char) for Lottery",
        "Close",
        {
          horizontalPosition: "right",
          verticalPosition: "top",
          panelClass: "warning-toast",
          duration: 3 * 1000,
        }
      );
      this.isSearchDisabled = false;
    }
  }
  downloadLetter(key: any) {
    console.log(key);

    this.masterService.downloadSop(key).subscribe(
      (data) => {
        this.isLoading = false;
        if (data.status === "SUCCESS") {
          console.log(data);
          this.downloadFile(data.base64File, data.fileName);
        } else {
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isLoading = false;
        this.errorToast(
          error?.error?.message ||
            error?.errorMessage ||
            error?.error?.errorMessage
        );
      }
    );
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.onLoad();
  }

  downloadFile(base64: string | ArrayBuffer, fileName: string) {
    const src = `${base64}`;
    const link = document.createElement("a");
    link.href = src;
    link.download = fileName;
    link.click();

    link.remove();
  }
  async errorToast(errorMessage: string) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }
}
